<template>
  <div class="app-container">
    <!-- 调试信息 -->
    <div v-if="debug" style="padding: 20px; background: #f0f0f0;">
      <p>当前路由: {{ $route.path }}</p>
      <p>路由元信息: {{ JSON.stringify($route.meta) }}</p>
    </div>
    
    <!-- 头部导航 - 根据路由类型显示不同的导航栏 -->
    <app-header v-if="!$route.meta.hideHeader && !isAdminRoute && !isTeacherRoute && !isStudentRoute"></app-header>
    
    <!-- 主要内容 -->
    <div class="main-content" :class="{ 'admin-content': isAdminRoute, 'teacher-content': isTeacherRoute, 'frontend-content': !isAdminRoute && !isTeacherRoute && !isStudentRoute && !$route.meta.hideHeader }">
      <router-view v-slot="{ Component }">
        <transition name="fade" mode="out-in">
          <keep-alive>
            <component :is="Component" />
          </keep-alive>
        </transition>
      </router-view>
    </div>
    
    <app-footer v-if="!$route.meta.hideFooter && !isAdminRoute && ($route.path === '/' || $route.path === '/teacher' || $route.path === '/teacher/home')"></app-footer>
    
    <!-- 超时监听组件 -->
    <timeout-listener />
  </div>
</template>

<script>
import AppHeader from '@/components/layout/AppHeader.vue'
import AppFooter from '@/components/layout/AppFooter.vue'
import TimeoutListener from '@/components/TimeoutListener.vue'
//管理员顶部标题
//import AdminHeader from '@/components/admin/layout/AdminHeader.vue'
import { ref, onMounted, onErrorCaptured, watchEffect } from 'vue'
import { ElMessage } from 'element-plus'
import { useRoute } from 'vue-router'
import { useSchoolStore } from '@/stores/school'

export default {
  name: 'App',
  components: {
    AppHeader,
    AppFooter,
    TimeoutListener,
    //AdminHeader
  },
  setup() {
    const debug = ref(false) // 关闭调试模式
    const route = useRoute()
    const schoolStore = useSchoolStore()

    const normalizeText = (value) => String(value ?? '').replace(/`/g, '').trim()
    
    onMounted(() => {
      console.log('App组件已挂载')
    })
    
    watchEffect(() => {
      const schoolName = normalizeText(schoolStore.getCurrentSchool?.name)
      const defaultTitle = schoolName || '在线测评考试平台'
      const pageTitle = route.meta?.title ? `${route.meta.title} - ${defaultTitle}` : defaultTitle
      document.title = pageTitle
    })

    onErrorCaptured((error, instance, info) => {
      console.error('捕获到错误:', error)
      console.error('错误实例:', instance)
      console.error('错误信息:', info)
      console.error('错误堆栈:', error.stack)
      // 不显示通用错误提示，让具体组件处理错误
      return false // 阻止错误继续传播
    })
    
    return {
      debug
    }
  },
  computed: {
    isAdminRoute() {
      return this.$route.path.startsWith('/admin')
    },
    isTeacherRoute() {
      return this.$route.path.startsWith('/teacher')
    },
    isStudentRoute() {
      return this.$route.path.startsWith('/student')
    }
  },
  watch: {
    '$route.path': {
      immediate: true,
      handler(newPath) {
        console.log('路由变化:', newPath)
        if (newPath.startsWith('/admin')) {
          document.body.classList.add('admin-page')
          document.body.classList.remove('teacher-page', 'student-page')
        } else if (newPath.startsWith('/teacher')) {
          document.body.classList.add('teacher-page')
          document.body.classList.remove('admin-page', 'student-page')
        } else if (newPath.startsWith('/student')) {
          document.body.classList.add('student-page')
          document.body.classList.remove('admin-page', 'teacher-page')
        } else {
          document.body.classList.remove('admin-page', 'teacher-page', 'student-page')
        }
      }
    }
  }
}
</script>

<style>
body {
  margin: 0;
  padding: 0;
  font-family: 'Helvetica Neue', Helvetica, 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', '微软雅黑', Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background-color: #f5f7fa;
}

.app-container {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.main-content {
  flex: 1;
  padding-top: 0;
  min-height: 400px; /* 添加最小高度 */
}

.admin-content {
  padding-top: 0px; /* 管理员页面不需要顶部间距 */
}

.teacher-content {
  padding-top: 0px; /* 教师页面使用TeacherLayout自己的间距 */
}

.frontend-content {
  padding-top: 60px; /* 为前台AppHeader留出空间 */
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

/* 学生页面特定样式 */
.student-page {
  /* 可以根据需要添加学生页面特定的全局样式 */
}
</style>
